// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveRoleStatusesForInstitutionUserHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import RoleStatusDTO from '../models/RoleStatusDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    userId: string | null;
    insttutionId: string | null;
    roleStatuses: RoleStatusDTO[] | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            userId: '00000000-0000-0000-0000-000000000000',
            insttutionId: '00000000-0000-0000-0000-000000000000',
            roleStatuses: [],
        },
        initValues);
    },
    userId: 'userId',
    insttutionId: 'insttutionId',
    roleStatuses: 'roleStatuses',
}

interface Result extends ResultDTO {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
        },
        initValues);
    },
}

export { Request, Result };